import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { IScreens } from '../Interfaces/IScreens';
import { ISitesConfigurations } from '../Interfaces/ISitesConfigurations';
import { RolesService } from '../services/roles-service';
import { SitesService } from '../services/sites-services';
import { SitesConfigurationsDetailsComponent } from './sites-configurations-details/sites-configurations-details.component';

declare var jQuery: any;

@Component({
  selector: 'sites-configurations',
  templateUrl: './sites-configurations.component.html',
  styles: [
  ]
})
export class SitesConfigurationsComponent implements OnInit {

  loading: boolean = false;
  listData: Array<ISitesConfigurations> = []
  station: string = 'TABLE';
  columns: Array<any> = [
		'configuration',
		'description',
    'value',
    'strlastupdated',
    'employeeupdatername',
    'siteconfigurationeditcolumn'
	];
  displayedColumns: Array<string> = this.columns.map((c) => c.columnDef);
  
  constructor(
		public translate: TranslateApplicationService,
		public notificationService: NotificationService,
		public dialog: MatDialog,
		private datePipe: DatePipe,
    public router: Router,
    private SitesService: SitesService,
    private roleService: RolesService
  ) { }

  ngOnInit(): void {
    this.loading = true;
		const component = this;
		jQuery('.btnReload').click(function () {
			component.GetSitesConfiguration();
		});
    this.GetSitesConfiguration()
  }

  GetSitesConfiguration() {
    this.loading = true;

    this.roleService.EmployeeHasPermissionToScreen('Projects').subscribe(
    (result: TransactionResult<IScreens[]>) => {
      this.loading = false;
      if (result.success) {
        if (result.data == null || result.data.length == 0)
          this.router.navigateByUrl('/main/without-permission');
      }
      else{
        this.loading = false;
				this.ErrorMessage('ROLES.Error_employee_has_permission');
				this.router.navigateByUrl('/main/without-permission');
			}
    },
    (error: any) => {
      this.ErrorAlert(error); this.loading = false; 
    });

    this.SitesService.GetSitesConfigurations().subscribe(
    (result: TransactionResult<ISitesConfigurations[]>) => {
      this.loading = false;
      if (result.success) {
        this.listData = result.data;
        
        this.listData.forEach((element) => {
          element.strlastupdated = this.datePipe.transform(
            element.lastupdated,
            'yyyy-MM-dd HH:mm:ss',
          );
        });
      }
      else{
        this.ErrorAlert(result.message);
      }
    },
    (error) => {
      this.ErrorAlert(error);
      this.loading = false;
    });
  }

  ErrorAlert(message: any) {
    this.notificationService.AddAlert({
      icon: 'all_inbox',
      title: 'Error',
      message: message,
      shown: true,
    });
  }

  EditSiteConfiguration(item: ISitesConfigurations) {
    const dialogRef = this.dialog.open(SitesConfigurationsDetailsComponent, {
			data: item
		});
		dialogRef.afterClosed().subscribe( result => {
			if(result){
				this.GetSitesConfiguration();
			}
		});
  }

	ErrorMessage(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: this.translate.TranslateKey(message),
			shown: true,
		});
	}
}
